import { render, staticRenderFns } from "./pdf-preview.vue?vue&type=template&id=cc0d8cbe&scoped=true&"
import script from "./pdf-preview.vue?vue&type=script&lang=js&"
export * from "./pdf-preview.vue?vue&type=script&lang=js&"
import style0 from "./pdf-preview.vue?vue&type=style&index=0&id=cc0d8cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0d8cbe",
  null
  
)

export default component.exports